import(/* webpackMode: "eager", webpackExports: ["MasterclassPageApp"] */ "/home/runner/work/monorepo/monorepo/apps/beemo/app/masterclasses/[masterclassId]/client.tsx");
